module.exports = __webpack_public_path__ + "static/media/interactive-pic-book-preview-02.75555709.jpg";